import * as React from 'react';
import { classes, st } from './image-component.st.css';
import { Image as ImageWUT, ImageLoadingBehaviorOptions, ImageResizeOptions } from 'wix-ui-tpa/cssVars';
const getResize = imageResize => {
  switch (imageResize) {
    case 'contain':
      return ImageResizeOptions.contain;
    case 'cover':
      return ImageResizeOptions.cover;
  }
  return undefined;
};
export function ImageComponentWUT(props) {
  const {
    imageResize = 'cover',
    imageAlignment = 'center'
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: st(classes.imageContainer, {
      imageAlignment,
      imageResize
    }),
    style: {
      // bug that aspectRatio is not working if it passed as number https://github.com/facebook/react/issues/21098#issuecomment-806965436
      aspectRatio: props.aspectRatio ? String(props.aspectRatio) : undefined
    }
  }, props.image ? /*#__PURE__*/React.createElement(ImageWUT, {
    alt: props.alt,
    key: props.image.id,
    resize: getResize(imageResize),
    src: props.image.id,
    loadingBehavior: ImageLoadingBehaviorOptions.spinner
  }) : null);
}
//# sourceMappingURL=image-component-wut.js.map